import * as yup from 'yup';

import { IBAN, isValidIdNumber, PhoneVO } from '@zazume/zzm-utils';

import { DocumentIDTypes, ProviderService } from '../../../../../models';

export const getProviderSchema = t => {
  const requiredMessage = t('general.forms.mandatory');
  return yup.object().shape({
    name: yup
      .string()
      .required(requiredMessage)
      .trim()
      .min(3, t('errorMessages.length', { length: 3 })),
    phone: yup
      .string()
      .transform(str => str.replace(/ /g, ''))
      .test('is-invalid-phone', t('general.forms.invalid'), value => (value ? PhoneVO.isValid(value) : true)),
    email: yup
      .string()
      .email(t('general.forms.emailError'))
      .transform(value => (value?.trim().length ? value : undefined)),
    documentIDType: yup.string().oneOf([...DocumentIDTypes], t('general.forms.idNotDefinedType')),
    idNumber: yup.string().when('documentIDType', (idCardType, schema) => {
      if (!idCardType) {
        return schema.max(0, t('general.forms.idNotDefinedType'));
      }

      return schema.test({
        test: (value?: string) => (value ? (isValidIdNumber(value, idCardType) as boolean) : false),
        message: t('general.forms.idNotValid')
      });
    }),
    address: yup.string(),
    iban: yup
      .string()
      .test('test-iban-number-length', t('general.forms.mandatory'), function (value) {
        const { path, createError } = this;

        if (!value) {
          return true;
        }

        const ibanCheck = IBAN.isValid(value);
        if (!ibanCheck) {
          return createError({ path, message: t('general.forms.ibanNotValid') });
        }
        return true;
      })
      .transform(value => (value?.trim().length ? value : undefined)),
    services: yup.object({}),
    billingData: yup
      .object()
      .shape({
        manualValidation: yup.boolean().optional().nullable()
      })
      .optional()
      .nullable()
  });
};

export interface ProviderFormInputs {
  name: string;
  phone?: string;
  email?: string;
  iban?: string;
  idNumber?: string;
  documentIDType?: string;
  nationality?: string;
  fullAddress?: string;
  services: {
    [key in ProviderService]?: boolean;
  };
  billingData?: {
    manualValidation?: boolean;
  };
}
